import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({
  title = "Mirats Quanto DIY - Perfect Audience for Research Studies",
  description = "Mirats Quanto DIY is an innovative platform designed for clients to effortlessly access the perfect audience for their research studies. Seamlessly integrate survey links from Qualtrics, Survey Monkey, and other platforms.",
  keywords = "Mirats Quanto DIY, survey research, audience targeting, Qualtrics integration, Survey Monkey, market research, data collection, research studies, survey platform, DIY research",
  ogTitle = "Mirats Quanto DIY - Perfect Audience for Research Studies",
  ogDescription = "Access the perfect audience for your research studies with Mirats Quanto DIY. Seamlessly integrate survey links from Qualtrics, Survey Monkey, and other platforms.",
  ogImage = "https://app.miratsquanto.com/og-image.jpg",
  ogUrl = "https://app.miratsquanto.com",
  canonicalUrl = "https://app.miratsquanto.com",
  pageType = "website",
  structuredData = null,
  robots = "index, follow",
}) => {
  const siteName = "Mirats Quanto DIY";
  const twitterHandle = "@MiratsQuanto";

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Mirats Insights Private Limited" />
      <meta name="robots" content={robots} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta httpEquiv="content-language" content="en-us" />
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="mobile-web-app-capable" content="yes" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph Tags */}
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:type" content={pageType} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={twitterHandle} />
      <meta name="twitter:creator" content={twitterHandle} />
      <meta name="twitter:title" content={ogTitle} />
      <meta name="twitter:description" content={ogDescription} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Additional SEO Tags */}
      <meta name="theme-color" content="#2563eb" />
      <meta name="msapplication-TileColor" content="#2563eb" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="apple-mobile-web-app-title" content={siteName} />
      
      {/* Favicon and Icons */}
      <link rel="icon" href="/favicons/favicon.ico" />
      <link rel="apple-touch-icon" sizes="180x180" href="/favicons/apple-touch-icon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicons/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicons/favicon-16x16.png" />
      <link rel="manifest" href="/favicons/site.webmanifest" />
      <link rel="mask-icon" href="/favicons/safari-pinned-tab.svg" color="#2563eb" />
      <meta name="msapplication-config" content="/favicons/browserconfig.xml" />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
